import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FileComponent } from '~ngx-shared/formly/components/file/file.component';
import { FieldWrapperProps } from '../../wrappers/field-wrapper/field-wrapper.component';

interface FileProps extends FieldWrapperProps {
  accept?: string;
  size?: number;
}

export interface FileFieldConfig extends FormlyFieldConfig<FileProps> {
  type?: 'file' | Type<FileTypeComponent>;
}

@Component({
  selector: 'lib-formly-file-type',
  templateUrl: './file-type.component.html',
  styleUrl: './file-type.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ReactiveFormsModule, FormlyModule, NgClass, FileComponent]
})
export class FileTypeComponent extends FieldType<FieldTypeConfig<FileProps>> {}
